/**
 * Parsing methods.
 * @module parse
 */
define(function(require, exports, module) {

    'use strict';

    var parseDecimal = function (decimalPlaces, amount) {
        Number.prototype.numberFormat = function (decimals, dec_point, thousands_sep) {
            dec_point = typeof dec_point !== 'undefined' ? dec_point : '.';
            thousands_sep = typeof thousands_sep !== 'undefined' ? thousands_sep : ',';
            var parts = this.toFixed(decimals).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep);
            return parts.join(dec_point);
        };
        if(amount < 0){
            return parseFloat(amount).numberFormat(decimalPlaces, ".", ",").replace("-","");
        }else{
            return parseFloat(amount).numberFormat(decimalPlaces, ".", ",");
        }
    }

    exports.parseAmount = function (currencyCode, currencyDecimal, amount) {
        if(amount < 0){
           return "-" + currencyCode + " " + parseDecimal(currencyDecimal,amount);
        }else{
           return currencyCode + " " + parseDecimal(currencyDecimal,amount);
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/utils/parse-amount.js
// module id = 36
// module chunks = 0